import script from "./AdminHeaderActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHeaderActions.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHeaderActions.vue?vue&type=style&index=0&id=55890b1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55890b1d"]])

export default __exports__